import { path } from 'd3-path'
import Symbol2d from '../2d.js'

const minPixels = 1

export default class Plus extends Symbol2d {

  handles = [{
    defaults: [.3, 0],
    constraints: (dimensions) => {
      const max1 = .5 - (minPixels / dimensions.width) // The vertical line must be at least minPixels from the center
      const max2 = ((.5 - (minPixels / dimensions.height)) * dimensions.height) / dimensions.width // Based on the height

      return [[minPixels / dimensions.width, Math.min(max1, max2)], null]
    },
    cursor: 'ew-resize'
  }]

  onDimensionsChange (dimensions, handles) {
    // Get the offset by using the previous dimensions
    const offset = this.getOffset(dimensions.previous, handles)

    if (dimensions.diff.width && dimensions.diff.height) {
      // Changing both dimensions, allow the handle to scale as normal
      return
    }

    if (dimensions.width > dimensions.height && dimensions.diff.width ) {
      // When the width is greater than the height, we want to lock the offset
      handles[0][0] = offset / dimensions.width
    }
  }

  getOffset (dimensions, handles) {
    return dimensions.width * handles[0][0]
  }

  path (dimensions, handles) {
      const _path = path()
      const offset = this.getOffset(dimensions, handles)

      _path.moveTo(offset, 0)
      _path.lineTo(dimensions.width - offset, 0)
      _path.lineTo(dimensions.width - offset, offset)
      _path.lineTo(dimensions.width, offset)
      _path.lineTo(dimensions.width, dimensions.height - offset)
      _path.lineTo(dimensions.width - offset, dimensions.height - offset)
      _path.lineTo(dimensions.width - offset, dimensions.height)
      _path.lineTo(offset, dimensions.height)
      _path.lineTo(offset, dimensions.height - offset)
      _path.lineTo(0, dimensions.height - offset)
      _path.lineTo(0, offset)
      _path.lineTo(offset, offset)
      _path.closePath()

      return _path.toString()
    }

  textContainer (dimensions, handles) {
    const offset = this.getOffset(dimensions, handles)
    const plusHeight = (dimensions.center[1] - offset) * 2

    return {
      width: dimensions.width,
      height: plusHeight,
      center: dimensions.center
    }
  }

}
